export default __webpack_public_path__ + "static/media/img--bathroom-light.e2f4d077.jpg";